<template>
  <div class="sportsDetail_inforPanel">
    <span
      class="detailInfor_left"
      :class="isOpenFlag ? 'act' : ''"
      @click="openMeun(isOpenFlag)"
    >
      <span class="detailInfor_left_colum1">
        <img
          :src="
            currSid === 'ASG2026'
              ? `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ASG2026/${currSportsDetail.sportsId}.png`
              : `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currSportsDetail.sportsId}.png`
          "
        />
      </span>
      <!-- <span class="detailInfor_left_colum2">
        <span
          class="nameItem"
          v-text="_valUnitFormatHandler(currSportsDetail.sportsName)"
        ></span>
        <span class="symbol" v-text="'·'"></span>
        <span
          class="nameItem"
          v-text="_valUnitFormatHandler(currSportsDetail.eventName)"
        ></span>
        <span
          class="select_icon el-icon el-icon-caret-bottom"
          :class="isOpenFlag ? 'open' : ''"
        ></span>
      </span> -->
      <span class="detailInfor_left_colum2">
        <span class="nameItem" v-text="detailInfor_title"></span>
        <span
          class="select_icon el-icon el-icon-caret-bottom"
          :class="isOpenFlag ? 'open' : ''"
        ></span>
      </span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'sportsDetail_inforPanel',
  mixins: [cup_base_data_mixin],
  props: {
    isOpenFlag: {
      type: Boolean,
      default: false,
    },
    currSportsDetail: {
      type: Object,
      default: () => ({
        sportsId: null,
        sportsName: null,
        evenId: null,
        eventName: null,
        matchId: null,
      }),
    },
    currSid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  created() {
    console.debug('currSportsDetail:', this.currSportsDetail)
  },
  computed: {
    detailInfor_title() {
      // 返回 【小项】
      let text = `${this._valUnitFormatHandler(
        this.currSportsDetail.sportsName
      )} · ${this._valUnitFormatHandler(this.currSportsDetail.eventName)}`

      return text
    },
  },
  methods: {
    openMeun(flag) {
      console.debug('clickIsOpenMeunEvent')
      this.$emit('clickIsOpenMeunEvent', !flag)
    },
    _valUnitFormatHandler(val, unit) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${unit ? unit : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.sportsDetail_inforPanel {
  height: 12.36vw;
  width: 100%;
  padding-top: 3.125vw;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .detailInfor_left {
    width: auto;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    .detailInfor_left_colum1 {
      width: 4.16vw;
      height: 4.16vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      border-radius: 50%;
      border: 0.208vw solid var(--mixtmt_whiteColor);
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .detailInfor_left_colum2 {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: auto;
      padding-left: 1.38vw;
      color: var(--mixtmt_whiteColor);
      font-weight: bold;
      .nameItem {
        padding: 0 0.694vw;
        font-size: 2.083vw;
      }
      .symbol {
        font-size: 2.78vw;
      }
      .select_icon {
        font-size: 1.38vw;
        transition: transform 0.3s linear;
        transform: rotate(0);
        &.open {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.mixtmt_pc .sportsDetail_inforPanel {
  .detailInfor_left {
    &:hover,
    &.act {
      cursor: pointer;
      .detailInfor_left_colum1 {
        border: 0.208vw solid var(--mixtmt_subColor4_1);
      }
      .detailInfor_left_colum2 {
        color: var(--mixtmt_subColor4_1);
      }
    }
  }
}
</style>
